import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1 pb-24 md:pb-0">{children}</main>
    <Footer />
    <StickyMobileCTA />
  </div>
);

export default PublicLayout;
